import {
  CircularProgress,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { tk } from "@thalamos/vision-common";

import { Banner } from "../../components/Banner/Banner.js";
import { MultiPagePdf } from "../../components/index.js";

export function PdfPreviewPage({
  pdfData,
  pdfLoading,
  pdfUnavailable,
}: {
  pdfData: string | null;
  pdfLoading: boolean;
  pdfUnavailable: boolean;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack data-testid="pdf-preview-page" spacing={3} sx={{ mt: 2 }}>
      {pdfUnavailable ? (
        <Banner
          bannerType="warning"
          body={tk("sharePage.pdfPreviewUnavailable")}
        />
      ) : pdfData ? (
        <MultiPagePdf data={pdfData} maxWidth={isMobile ? 350 : 550} />
      ) : pdfLoading ? (
        <CircularProgress />
      ) : null}
    </Stack>
  );
}
